import { publicToken } from "./helpers"

/**
 * Retrieve related product data for swatches
 * @param {string[]} valuesToFetch - 'product-app_color_variants' value from products
 * @returns {Promise<Object|null>}
 */
 export const fetchColorProducts = async (valuesToFetch) => {
    try {
        const res = await fetch('https://api.nosto.com/v1/graphql', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/graphql',
                'Authorization': 'Basic ' + btoa(publicToken)
            }),
            mode: 'cors',
            body: `
                query {
                    products(
                        limit: 25, 
                        filter: {
                            customFields: [{
                                attribute: "product-app_color_variants"
                                values: ${JSON.stringify(valuesToFetch)}
                            }]
                        }
                    ) {
                        products {
                            productId
                            name
                            availability
                            url
                            price
                            listPrice
                            imageUrl
                            alternateImageUrls
                            attributes {
                                key
                                value
                            }
                            skus {
                                id
                                name
                                availability
                                attributes {
                                    key
                                    value
                                }
                            }
                        }
                    }
                }
            `
        });
        return await res.json();
    } catch (err) {
        console.error(err);
        return null;
    }
}

/** Subscribes to notifications when size is out of stock
 * @param {boolean} acceptsSms - checked SMS subscription
 * @param {string} email - validated email
 * @param {string} phone - validated and parsed phone
 * @param {string} url - API url from technical data
 * @param {string} sourceId - source id from technical data
 * @returns {Promise<Object|null>}
 */
export const subscribeToSms = (acceptsSms, email, phone, url, sourceId) => {
    if (!acceptsSms || !sourceId) return;

    const request = {
        user: { email, phone },
        signUpSourceId: sourceId,
        locale: { language: 'en', country: 'US' },
        subscriptionType: 'MARKETING',
    };

    fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
        },
        body: JSON.stringify(request),
    })
    .then((response) => response.json())
    .then((data) => console.log(data))
    .catch((error) => console.error('Error:', error));
}